export const workspace = {
  routes: [
    {
      path: "/workspace/library/possible-effect",
      component: () => import("../workspace-library-possible-effect-view"),
    },
  ],
};
export const management = {
  routes: [
    {
      path: "/management/possible-effect",
      component: () => import("../management-library-possible-effect-view"),
    },
  ],
};
